import mapInfoStore from "../store/mapInfo";

// Custom hook để sử dụng và cập nhật cấu hình player
const useMapInfo = (playerId) => {
    const maps = mapInfoStore((state) => state.map);
    const setMap = mapInfoStore((state) => state.setMap);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        map: playerId == null ? {} : maps[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        maps,
        setMap,
    };
};

export default useMapInfo;
